import React, { FC, MouseEvent, MouseEventHandler } from 'react';
import Classnames from 'classnames';

const Arrow: FC = () => (
  <svg className="arrow">
    <use xlinkHref="#icon__arrow" />
  </svg>
);

interface Props {
  label: string;
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  onDisabledClick?: MouseEventHandler<HTMLButtonElement>;
}

export const NextStepButton: FC<Props> = ({ label, disabled, onClick, onDisabledClick }) => {
  const cls = Classnames('button with-arrow alt', { disabled });

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    if (disabled) {
      e.preventDefault();
      onDisabledClick?.(e);
    } else {
      onClick?.(e);
    }
  };

  return (
    <div className="cart-end">
      <button id="StepButton" type="submit" className={cls} onClick={handleClick} aria-disabled={disabled}>
        {label}
        <Arrow />
      </button>
    </div>
  );
};
